var $schema = "https://schemas.wp.org/trunk/block.json";
var version = "1.0";
var name = "constellation/agent-search";
var title = "Agent Search";
var description = "Search for agents";
var icon = "businessperson";
var keywords = ["agent", "search"];
var supports = {
  customClassName: false,
  html: false
};
var category = "more";
var attributes = {
  search: {
    type: "string",
    "default": "zip",
    label: "Search Type",
    control: "select",
    choices: [{
      label: "Zip",
      value: "zip"
    }, {
      label: "Installations",
      value: "installations"
    }]
  },
  placeholder: {
    type: "string",
    label: "Placeholder",
    "default": "Enter Zip Code",
    control: "text"
  }
};
var json = {
  $schema: $schema,
  version: version,
  name: name,
  title: title,
  description: description,
  icon: icon,
  keywords: keywords,
  supports: supports,
  category: category,
  attributes: attributes
};

export { $schema, attributes, category, json as default, description, icon, keywords, name, supports, title, version };
